import ITSVG from "common/helpers/ITSVG";
import searchIcon from 'assets/images/icons/search.svg';
import { Department } from "../model/step";
import { useTranslation } from "react-i18next";
import filterIcon from 'assets/images/icons/filter.svg';
import { Autocomplete, TextField } from "@mui/material";
import { errorReceivedCallback } from "msal";
import { useEffect } from "react";
import { MenuComponent } from "assets/ts/components";
import i18next from "i18next";
import en from '../i18n/en-us.json';
import pt from '../i18n/pt-br.json';
import es from '../i18n/es-es.json';


export interface Props {
    departments: Department[],
    onSearch: (e: string) => void,
    onFilter: (e?: Department) => void
}

export function StepFilter(props: Props) {
    i18next.addResourceBundle('us', 'translation', en);
    i18next.addResourceBundle('br', 'translation', pt);
    i18next.addResourceBundle('es', 'translation', es);
    const { t } = useTranslation();

    useEffect(() => {
        //kt-menu issue
        //https://devs.keenthemes.com/question/kt-menu-not-opening-on-rerender
        MenuComponent.reinitialization();
    }, []);

    return (
        <div className="card-title mb-1 d-flex justify-content-between">
            <div className="d-flex align-items-center position-relative my-1">
                <ITSVG path={searchIcon} className={'svg-icon-1 position-absolute ms-6'} />
                <input
                    type="text"
                    className="form-control form-control-solid w-250px ps-14"
                    placeholder={`${t('searchInput.placeholder')}`}
                    name="searchInput"
                    onChange={(e) => props.onSearch(e.target.value)}
                />
            </div>
            <div>
                <button
                    type='button'
                    className='btn btn-sm btn-flex btn-light btn-active-primary fw-bolder'
                    data-kt-menu-placement='bottom-end'
                    data-kt-menu-trigger="click"
                    data-kt-menu-attach="parent"
                    data-kt-menu-flip="bottom"
                    id="kt_filter-step"
                >
                    <ITSVG path={filterIcon} className='svg-icon-5 svg-icon-gray-500 me-1' />
                    {t('generalMessages.filter')}
                </button>

                <div data-kt-menu="true" className="menu menu-sub menu-sub-dropdown w-250px">
                    <div className='px-7 py-5'>
                        <div className='fs-5 text-dark fw-bolder'>{t('generalMessages.filterOptions')}</div>
                    </div>
                    <div className='separator border-gray-200'></div>
                    <div className='px-7 py-5'>
                        <div className='mb-10'>
                            <label className='form-label fw-bold'>{t('notificationCenter.stepFilter.department')}</label>
                            <Autocomplete
                                id='status'
                                options={props.departments.map(e => ({ label: e.name, value: e.id }))}
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                onChange={(_, value) => { props.onFilter(value != null ? { id: value.value, name: value.label } : undefined) }}
                                renderInput={(params) =>
                                    <TextField
                                        placeholder={`${t('generalMessages.select')}`}
                                        {...params}
                                    />
                                }
                                noOptionsText={t('generalMessages.noOptions')}
                            />
                        </div>
                        <div className='d-flex justify-content-end'>
                            <button
                                type='reset'
                                className='btn btn-sm btn-white btn-active-light-primary me-2'
                                data-kt-menu-dismiss='true'
                            >
                                {t('generalMessages.cancel')}
                            </button>
                            <button
                                type='button'
                                className='btn btn-sm btn-primary'
                                data-kt-menu-dismiss='true'
                            >
                                {t('generalMessages.apply')}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div >

    )
}